<template>
  <div class="permission-list">
    <Collapse simple v-model="tableToolsPanel" class="table-tools-panel" accordion>
      <Panel name="filter" hide-arrow>
        <div class="table-tools-panel-title"><Icon class="table-tools-panel-title-icon" type="ios-funnel" />筛选</div>
        <div class="pull-right">
          <Tooltip content="刷新结果">
            <Button @click.stop="refresh" type="text" size="large" icon="ios-refresh"></Button>
          </Tooltip>
          <Divider type="vertical" />
          <Tooltip :content="(tableToolsPanel.indexOf('filter')>-1? '隐藏':'展开')+'筛选条件'">
            <Button type="text" size="large" :icon="tableToolsPanel.indexOf('filter')>-1? 'ios-arrow-up':'ios-arrow-down'"></Button>
          </Tooltip>
        </div>
        <div slot="content">
          <div class="padding-top-20"></div>
          <Form ref="filterForm" :model="filterModel" inline :show-message="false" :label-width="110">
            <Row :gutter="8">
              <i-col span="8">
                <FormItem label="名称" prop="name">
                  <Input v-model="filterModel.name" placeholder="输入名称" />
                </FormItem>
              </i-col>
              <i-col span="8">
                <FormItem label="私有" prop="isPrivate">
                  <RadioGroup v-model="filterModel.isPrivate" type="button">
                    <Radio :label="null">不限</Radio>
                    <Radio :label="1">专属</Radio>
                    <Radio :label="0">通用</Radio>
                  </RadioGroup>
                </FormItem>
              </i-col>
            </Row>
            <Row :gutter="8">
              <i-col span="8">
                <FormItem label="Controller" prop="controller">
                  <Input v-model="filterModel.controller" placeholder="输入Controller名称" />
                </FormItem>
              </i-col>
              <i-col span="8">
                <FormItem label="Action" prop="action">
                  <Input v-model="filterModel.action" placeholder="输入Action名称" />
                </FormItem>
              </i-col>
            </Row>
            <Row :gutter="8">
              <i-col span="8">
                <FormItem label="CA签名" prop="needCert">
                  <RadioGroup v-model="filterModel.needCert" type="button">
                    <Radio :label="null">不限</Radio>
                    <Radio :label="1">是</Radio>
                    <Radio :label="0">否</Radio>
                  </RadioGroup>
                </FormItem>
              </i-col>
              <i-col span="8">
                <FormItem label="多因素验证" prop="needMultiFactor">
                  <RadioGroup v-model="filterModel.needMultiFactor" type="button">
                    <Radio :label="null">不限</Radio>
                    <Radio :label="1">是</Radio>
                    <Radio :label="0">否</Radio>
                  </RadioGroup>
                </FormItem>
              </i-col>
            </Row>
            <Row :gutter="8">
              <i-col span="16">
                <FormItem style="width: 100%; text-align:right">
                  <Button type="primary" size="large" style="width:144px;" @click="refresh">查询</Button>
                  <Divider type="vertical" />
                  <Button type="error" ghost size="large" @click="$refs['filterForm'].resetFields()">重置</Button>
                </FormItem>
              </i-col>
            </Row>
          </Form>
        </div>
      </Panel>
    </Collapse>
    <div class="padding-top-10"></div>
    <div class="text-right">
      <Button type="primary" to="/permissions/new" icon="md-add">新增基础权限</Button>
    </div>
    <div class="padding-top-10"></div>
    <!-- <Alert type="success" show-icon><b>导入完成！</b>成功 1 条，失败 0 条。</Alert> -->
    <Table border ref="dataTable"
      size="small"
      stripe
      :columns="columns"
      @on-sort-change="tableSortChange"
      :data="data">
    </Table>
    <Page class="pager"
      :total="totalCount"
      :current="currentPageIndex"
      @on-change="changePageIndex"
      @on-page-size-change="changePageSize"
      size="small"
      show-elevator
      show-total
      show-sizer />
  </div>
</template>

<script>
export default {
  name: 'permission-list',
  props: {
  },
  data () {
    return {
      tableToolsPanel: '',
      columns: [
        {
          title: '名称',
          key: 'name',
          resizable: true,
          sortable: 'custom',
          sortMethod: (a, b, type) => {
            if (type === 'asc') {
              return a.localeCompare(b, 'zh-CN')
            } else {
              return b.localeCompare(a, 'zh-CN')
            }
          }
        },
        {
          title: 'Controller',
          key: 'controller',
          resizable: true,
          width: 150,
          sortable: 'custom'
        },
        {
          title: 'Action',
          key: 'action',
          resizable: true,
          width: 150,
          sortable: 'custom'
        },
        {
          title: '专属',
          key: 'isPrivate',
          sortable: 'custom',
          render: (h, params) => {
            if (!params.row.isPrivate) {
              return h('Tag', {
                props: {
                  color: 'default'
                }
              }, '通用')
            } else {
              if (params.row.ownedByCityId && params.row.ownedByCityName) {
                return h('Tag', {
                  props: {
                    color: 'primary'
                  }
                }, params.row.ownedByCityName + '专属')
              }
              if (params.row.ownedByIndustryId && params.row.ownedByIndustryName) {
                return h('Tag', {
                  props: {
                    color: 'success'
                  }
                }, params.row.ownedByIndustryName + '专属')
              }
            }
          }
        },
        {
          title: 'CA签名',
          key: 'needCert',
          sortable: 'custom',
          render: (h, params) => {
            return h('Tag', {
              props: {
                color: params.row.needCert ? 'primary' : 'default'
              }
            }, params.row.needCert ? '开启' : '关闭')
          }
        },
        {
          title: '多因素验证',
          key: 'needMultiFactor',
          sortable: 'custom',
          render: (h, params) => {
            return h('Tag', {
              props: {
                color: params.row.needMultiFactor ? 'primary' : 'default'
              }
            }, params.row.needMultiFactor ? '开启' : '关闭')
          }
        },
        {
          title: '操作',
          width: 120,
          render: (h, params) => {
            return h('span', null, [
              h('Tooltip', {
                props: {
                  content: '修改',
                  transfer: true
                }
              }, [
                h('Button', {
                  props: {
                    type: 'warning',
                    ghost: true,
                    shape: 'circle',
                    icon: 'md-create'
                  },
                  on: {
                    click: () => {
                      // let userId = params.row.id
                      this.$router.push({name: 'permission-edit', params: {permission: params.row}})
                    }
                  }
                }, null),
              ]),
              h('span', null, ' '),
              h('Tooltip', {
                props: {
                  content: '删除',
                  transfer: true
                }
              }, [
                h('Button', {
                  props: {
                    type: 'error',
                    ghost: true,
                    shape: 'circle',
                    icon: 'ios-trash-outline'
                  },
                  on: {
                    click: () => {
                      let permissioId = params.row.tid
                      this.deletePermission(permissioId)
                    }
                  }
                }, null)
              ])
            ])
          }
        }
      ],
      data: [],
      pageSize: 10,
      totalCount: 0,
      currentPageIndex: 1,
      filterModel: {
        name: null,
        controller: null,
        action: null,
        isPrivate: null,
        needCert: null,
        needMultiFactor: null
      },
      departments: [],
      curDepartmentId: null
    }
  },
  watch: {
    currentPageIndex: function (newVal) {
      if (newVal) {
        this.initData()
      }
    },
    pageSize: function (newVal) {
      if (newVal) {
        this.initData()
      }
    },
  },
  mounted () {
    this.initData()
  },
  activated () {
  },
  deactivated () {
  },
  methods: {
    refresh () {
      // console.log('123')
      this.initData()
    },
    changePageSize (e) {
      this.pageSize = e
    },
    changePageIndex (e) {
      this.currentPageIndex = e
    },
    tableSortChange (e) {
      if (e.key) {
        this.filterModel.sortBy = e.column.sortKey || e.key
        this.filterModel.ascending = e.order === 'normal' ? null : e.order == 'asc' ? true : false
        this.initData()
      }
    },
    async initData () {
      this.$Spin.show()
      let res = await this.$Api.BasicPermission.listBasicPermissions(this.filterModel, this.currentPageIndex, this.pageSize).catch(err => {
        this.$Message.error(err.message)
        this.$Spin.hide()
      })
      this.totalCount = res.totalCount
      this.currentPageIndex = res.currentPage
      this.pageSize = res.pageSize
      this.data = res.data
      this.$Spin.hide()
    },
    async deletePermission (permissionId) {
      this.$Modal.confirm({
        title: '确认操作',
        content: '<p>确认删除该基础权限么？</p>',
        onOk: async () => {
          // this.$Spin.show()
          await this.$Api.BasicPermission.deleteBasicPermission(permissionId).catch(err => {
            this.$Notice.error({
              title: '操作失败!',
              desc: err.message
            })
            // this.$Spin.hide()
            return null
          })
          this.$Message.success('操作成功!')
          this.data.splice(this.data.findIndex(o => {return o.id === permissionId}), 1)
          this.totalCount -= 1
        },
        onCancel: () => {
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.table-tools-panel {
  .table-tools-panel-title {
    font-weight: bold;
    display: inline-block;
  }
  .table-tools-panel-title-icon {
    margin-right: 20px;
  }
  .table-tools-panel-title-addon {
    display: inline-block;
    margin-left: 20px;
  }
}
.pager {
  margin: 20px 0;
}
</style>
